export const isReportMissing = (week, reports) => {
    const strWeek = String(week)
    const hasReport = reports?.some((report) => String(report.week) === strWeek) ?? false
    return !hasReport
}

export const getNhsrSubmissionStatus = (week, reports) => {
    if (!isReportMissing(week, reports)) return "submitted"
    if (Number(week) === 1 || !isReportMissing(Number(week) - 1, reports)) return "not-due"
    return "missing"
}
